import { QuestionForMain } from "@/components/features/_layouts/island/main/question";

import { InputTextFieldRHF } from "@/components/ui/form/fields-rhf/input-field/input-text";

import { useGoogleFreeBookingLinksSettingsContext } from "../../../_context";

export const FormHotelName = () => {
	const { form } = useGoogleFreeBookingLinksSettingsContext();
	const {
		register,
		formState: { errors },
	} = form;

	return (
		<QuestionForMain
			title={"施設名"}
			required
			inputChildren={
				<InputTextFieldRHF
					errorMessage={errors?.hotelName?.message}
					className="w-2/3 min-w-72"
					{...register("hotelName")}
				/>
			}
		/>
	);
};
